export function showConfirmDialog(settings) {
    const promise = newVueApp.$refs.confirmDialog.show(settings);

    if (settings.confirm) {
        promise.then(settings.confirm);
    }

    if (settings.cancel) {
        promise.catch(settings.cancel);
    }

    return promise;
}

export function showInputDialog(settings) {
    const promise = newVueApp.$refs.inputDialog.show(settings);

    if (settings.confirm) {
        promise.then(settings.confirm);
    }

    if (settings.cancel) {
        promise.catch(settings.cancel);
    }

    return promise;
}

function waitForElement(refName, timeout = 5000, callback) {
    const startTime = Date.now();

    const interval = setInterval(() => {
        if (window.newVueApp && window.newVueApp.$refs && window.newVueApp.$refs[refName]) {
            clearInterval(interval);
            callback(null, window.newVueApp.$refs[refName]);
        } else if (Date.now() - startTime >= timeout) {
            clearInterval(interval);
            callback(new Error(`${refName} not found within ${timeout}ms`), null);
        }
    }, 100);
}

export function showInfoMessage(msg, callback, timeout) {
    waitForElement('infoMessageDialog', 5000, (error, dialog) => {
        if (error) {
            console.error(error);
        } else {
            dialog.show(msg, callback, timeout);
        }
    });
}

export function showErrorMessage(msg, callback, timeout) {
    waitForElement('errorMessageDialog', 5000, (error, dialog) => {
        if (error) {
            console.error(error);
        } else {
            dialog.show(msg, callback, timeout);
        }
    });
}